import { colorPalette } from '@rakutenfrance/mui';
export const container = () => ({
    marginTop: '1.6rem',
    color: colorPalette.gray1000,
    lineHeight: '24px',
    textDecorationColor: colorPalette.gray1000,
    '& < Box': {
        fontWeight: 400,
    },
});
export const subtitle = () => ({
    fontWeight: 600,
});
export const linkText = () => ({
    color: colorPalette.gray1000,
    fontSize: '12px',
    '&:hover': {
        textDecoration: 'underline',
    },
});
export const banner = () => ({
    display: 'flex',
    justifyContent: 'center',
});
